import api from './api';

export function attach() {

    return new Promise((resolve) => {

        if (!document.cookie.match('.*sso_attached.*')) {

            return api
                .get('/sso/attach-url')
                .then((res) => {

                    let image = document.createElement('img');

                    image.onload = resolve;
                    image.src = res['payload'];

                    document.body.appendChild(image);
                });
        }

        resolve();
    });
}